import { render, staticRenderFns } from "./MarketLockedModals.vue?vue&type=template&id=3149d5b4&"
import script from "./MarketLockedModals.vue?vue&type=script&lang=js&"
export * from "./MarketLockedModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports